import { FSWatcher, watch } from "chokidar";
import _ from "lodash";

import { WellKnownDirectories } from "../../../../Common/WellKnownDirectories";

import { ObservableValueProducerBase } from "./ChainableValueProducer";
import { eventBus, FORM_REMOVE_EVENT } from "./EventBus";

type FsEvent = "add" | "addDir" | "change" | "unlink" | "unlinkDir";

export class FileValueProducer extends ObservableValueProducerBase<string> {
    private readonly pathToFile: string;
    private watcher?: FSWatcher;

    public constructor(pathToFile: string) {
        super();
        this.pathToFile = pathToFile;
    }

    protected async beginListening(): Promise<void> {
        if (this.watcher != undefined) {
            return;
        }
        this.watcher = watch(this.pathToFile, {
            ignoreInitial: true,
            ignorePermissionErrors: false,
            usePolling: true,
        });
        const handleAnyFsEventDebounced = _.debounce((event: FsEvent) => this.handleAnyFsEvent(event), 1000);
        this.watcher.on("all", handleAnyFsEventDebounced);
        this.watcher.on("error", handleAnyFsEventDebounced);
    }

    protected async stopListening(): Promise<void> {
        if (this.watcher != undefined) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.watcher.close();
        }
    }

    protected async getCurrentValue(): Promise<string> {
        return this.pathToFile;
    }

    private async handleAnyFsEvent(event: FsEvent): Promise<void> {
        if (event === "unlink" && this.pathToFile.includes(WellKnownDirectories.FormJsonFileName)) {
            eventBus.emit(FORM_REMOVE_EVENT);
        }

        await this.emitUpdate(this.pathToFile);
    }
}
